export const paymentOptions = [
  { label: 'Giữ chỗ', value: 'reserve' },
  { label: 'Tiền mặt', value: 'cash' },
  { label: 'Chuyển khoản ngân hàng', value: 'bank_transfer' },
  { label: 'Tài khoản đại lý', value: 'agent_balance', disabled: true },
  { label: 'Tại nhà xe', value: 'paid_at_company', disabled: true },
];
export const paymentMultiOptions = [
  { label: 'Giữ chỗ', value: 'reserve' },
  { label: 'Tiền mặt', value: 'cash' },
  { label: 'Chuyển khoản ngân hàng', value: 'bank_transfer' },
];
export const paymentAgentOptions = [
  { label: 'Giữ chỗ', value: 'reserve' },
  { label: 'Tài khoản đại lý', value: 'agent_balance' },
  { label: 'Tại nhà xe', value: 'paid_at_company' },
];
export const paymentAgentBalanceOptions = [
  { label: 'Giữ chỗ', value: 'reserve', disabled: true },
  { label: 'Tài khoản đại lý', value: 'agent_balance' },
  { label: 'Tại nhà xe', value: 'paid_at_company' },
];
export const paymentPaidCompanyOptions = [
  { label: 'Giữ chỗ', value: 'reserve', disabled: true },
  { label: 'Tiền mặt', value: 'cash' },
  { label: 'Chuyển khoản ngân hàng', value: 'bank_transfer' },
  { label: 'Tài khoản đại lý', value: 'agent_balance', disabled: true },
  { label: 'Tại nhà xe', value: 'paid_at_company', disabled: true },
];
export const agentBalanceOption = [
  {
    label: 'Tài khoản đại lý',
    value: 'agent_balance',
    disabled: true,
  },
];
export const cashOption = [
  {
    label: 'Tiền mặt',
    value: 'cash',
    disabled: false,
  },
  {
    label: 'Chuyển khoản ngân hàng',
    value: 'bank_transfer',
    disabled: false,
  },
];
export const bankOption = [
  {
    label: 'Chuyển khoản ngân hàng',
    value: 'bank_transfer',
    disabled: false,
  },
  {
    label: 'Tiền mặt',
    value: 'cash',
    disabled: false,
  },
];
export const cashAgentOption = [
  {
    label: 'Tiền mặt',
    value: 'cash',
    disabled: true,
  },
];
export const bankAgentOption = [
  {
    label: 'Chuyển khoản ngân hàng',
    value: 'bank_transfer',
    disabled: true,
  },
];
export const agentContractPaidOptions = [{ label: 'Tài khoản đại lý', value: 'agent_balance', disabled: true }];
export const paymentContractOptions = [
  { label: 'Tiền mặt', value: 'cash' },
  { label: 'Chuyển khoản ngân hàng', value: 'bank_transfer' },
];
export const paymentAgentContractOptions = [{ label: 'Tài khoản đại lý', value: 'agent_balance' }];

export const validatorEmailBooking: any = [{ type: 'email', message: 'Email không đúng định dạng' }];

export const bookingNoDiagramData = [
  {
    ticket_code: '4N0C8D',
    customer: {
      name: 'Ánh Tuyết',
      phone: '0984585215',
    },
    pickup_location: {
      name: 'Hà Nội',
      address: '76 P. Thọ Lão, Đống Mác, Hai Bà Trưng, Hà Nội',
    },
    drop_off_location: {
      name: 'Quảng Bình',
      address: 'Ngã 3 sân bay, QL1A, Lộc Ninh, Đồng Hới, Quảng Bình',
    },
    source: 'Carlink API',
    final_price: '230,000',
    receivable: '230,000',
    pickup_extra: null,
    drop_off_extra: null,
  },
  {
    ticket_code: '1CBRT9',
    customer: {
      name: 'Vũ Linh Chi',
      phone: '0984585215',
    },
    pickup_location: {
      name: 'Quảng Bình',
      address: 'Ngõ 57 Hữu Nghị, Đồng Phú, Đồng Hới, Quảng Bình',
    },
    drop_off_location: {
      name: 'Đà Nẵng',
      address: '34 Hồ Tùng Mậu, Hoà Minh, Liên Chiểu, Đà Nẵng',
    },
    source: 'Carlink API',
    final_price: '480,000',
    receivable: '480,000',
    pickup_extra: null,
    drop_off_extra: null,
  },
];
